"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoxPosition = void 0;
const MIN_MARGIN_FROM_EDGE = 5;
const getAttachedBoxPosition = position => {
  switch (position) {
    case 'top':
      return {
        top: 0,
        right: 'unset',
        bottom: 'unset',
        left: '50%',
        transform: 'translateX(-50%)',
        positionedOn: 'top'
      };
    case 'right':
      return {
        top: '50%',
        right: 0,
        bottom: 'unset',
        left: 'unset',
        transform: 'translateY(-50%)',
        positionedOn: 'right'
      };
    case 'bottom':
      return {
        top: 'unset',
        right: 'unset',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        positionedOn: 'bottom'
      };
    case 'left':
      return {
        top: '50%',
        right: 'unset',
        bottom: 'unset',
        left: 0,
        transform: 'translateY(-50%)',
        positionedOn: 'left'
      };
  }
};
const getFloatingBoxPosition = params => {
  const {
    anchorRect,
    boxRect,
    position,
    direction,
    offset,
    viewHeight,
    viewWidth,
    isCenteredToAnchor
  } = params;
  const boxWidth = Math.max(boxRect.width, anchorRect.width);
  const right = Math.max(anchorRect.left + anchorRect.width, anchorRect.right); //sometimes the anchorRect.right is off
  const canBoxBeOnTop = anchorRect.top - boxRect.height - offset >= 0;
  const canBoxBeOnRight = viewWidth - right - boxWidth - offset >= 0;
  const canBoxBeOnBottom = viewHeight - anchorRect.top - anchorRect.height - boxRect.height - offset >= 0;
  const canBoxBeOnLeft = anchorRect.left - boxWidth - offset >= 0;
  let leftPosition = undefined;
  let rightPosition = undefined;
  if (isCenteredToAnchor) {
    rightPosition = direction === 'rtl' ? Math.max(viewWidth - anchorRect.right + anchorRect.width / 2 - boxWidth / 2, MIN_MARGIN_FROM_EDGE) : undefined;
    leftPosition = direction === 'ltr' ? Math.max(anchorRect.left + anchorRect.width / 2 - boxWidth / 2, MIN_MARGIN_FROM_EDGE) : undefined;
  } else {
    if (direction === 'rtl') {
      rightPosition = Math.max(viewWidth - anchorRect.right, MIN_MARGIN_FROM_EDGE);
      leftPosition = undefined;
    } else {
      leftPosition = anchorRect.left;
      rightPosition = undefined;
    }
  }
  const minWidth = anchorRect.width;
  let alternativePosition = position;
  switch (position) {
    case 'top':
      {
        if (!canBoxBeOnTop && canBoxBeOnBottom) {
          alternativePosition = 'bottom';
        } else if (!canBoxBeOnTop && !canBoxBeOnBottom && canBoxBeOnRight) {
          alternativePosition = 'right';
        } else if (!canBoxBeOnTop && !canBoxBeOnBottom && !canBoxBeOnRight && canBoxBeOnLeft) {
          alternativePosition = 'left';
        } else {
          return {
            top: anchorRect.top - boxRect.height - offset,
            left: leftPosition,
            right: rightPosition,
            minWidth,
            positionedOn: 'top'
          };
        }
        break;
      }
    case 'right':
      {
        if (!canBoxBeOnRight && canBoxBeOnBottom) {
          alternativePosition = 'bottom';
        } else if (!canBoxBeOnRight && !canBoxBeOnBottom && canBoxBeOnLeft) {
          alternativePosition = 'left';
        } else if (!canBoxBeOnRight && !canBoxBeOnBottom && !canBoxBeOnLeft && canBoxBeOnTop) {
          alternativePosition = 'top';
        } else {
          const top = anchorRect.top + anchorRect.height / 2 - boxRect.height / 2;
          if (top > 0 || !canBoxBeOnBottom) {
            return {
              top,
              left: right + offset,
              minWidth,
              positionedOn: 'right'
            };
          } else {
            alternativePosition = 'bottom';
          }
        }
        break;
      }
    case 'bottom':
      {
        if (!canBoxBeOnBottom && canBoxBeOnTop) {
          alternativePosition = 'top';
        } else if (!canBoxBeOnBottom && !canBoxBeOnTop && canBoxBeOnRight) {
          alternativePosition = 'right';
        } else if (!canBoxBeOnBottom && !canBoxBeOnTop && !canBoxBeOnRight && canBoxBeOnLeft) {
          alternativePosition = 'left';
        } else {
          return {
            top: anchorRect.top + anchorRect.height + offset,
            left: leftPosition,
            right: rightPosition,
            minWidth,
            positionedOn: 'bottom'
          };
        }
        break;
      }
    case 'left':
      {
        if (!canBoxBeOnLeft && canBoxBeOnBottom) {
          alternativePosition = 'bottom';
        } else if (!canBoxBeOnLeft && !canBoxBeOnBottom && canBoxBeOnRight) {
          alternativePosition = 'right';
        } else if (!canBoxBeOnLeft && !canBoxBeOnBottom && !canBoxBeOnRight && canBoxBeOnTop) {
          alternativePosition = 'top';
        } else {
          const top = anchorRect.top + anchorRect.height / 2 - boxRect.height / 2;
          if (top > 0 || !canBoxBeOnBottom) {
            return {
              top,
              left: anchorRect.left - boxRect.width - offset,
              minWidth,
              positionedOn: 'left'
            };
          } else {
            alternativePosition = 'bottom';
          }
        }
        break;
      }
  }
  return getFloatingBoxPosition({
    anchorRect,
    boxRect,
    position: alternativePosition,
    direction,
    offset,
    viewHeight,
    viewWidth,
    isCenteredToAnchor
  });
};
const getBoxPosition = params => {
  if (params.isAttachedToWindow) {
    return getAttachedBoxPosition(params.position);
  } else {
    return getFloatingBoxPosition(params);
  }
};
exports.getBoxPosition = getBoxPosition;